var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logoUrl)?_c('div',{staticClass:"logo-block"},[_c('img',{staticClass:"logo center",attrs:{"src":_vm.logoUrl,"title":"Application"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }